<template>
  <div>
    <div class="type-wrap">
      <span
        v-for="(item,index) in types"
        :key="index"
        :class="{actived:type === item.key}"
        @click="switchType(item.key)"
      >{{item.value}}</span>
      <!-- <span :class="{actived:type === 'quarter'}" @click="switchType('quarter')">季度</span>
      <span :class="{actived:type === 'month'}" @click="switchType('month')">月度</span>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    types: Array,
    type: String
  },
  data() {
    return {};
  },
  methods: {
    switchType(value) {
      this.$emit("switchType", value);
    }
  }
};
</script>

<style lang="less" scoped>
.type-wrap {
  display: inline-block;
  height: 32px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  text-align: center;
  font-size: 14px;
  margin-right: 10px;
  > span {
    display: inline-block;
    width: 70px;
    height:32px;
    line-height: 32px;
    position: relative;
    cursor: pointer;
    &.actived {
      background-color: #2d8cf0;
      color: #fff;
      border-radius: 4px;
      height: 30px;
    }
  }

}
</style>